var _defs, _path, _path2, _path3, _path4, _path5, _line, _line2, _line3, _line4, _line5, _path6, _line6, _line7, _line8, _line9, _line10, _path7, _line11, _line12, _line13, _line14, _line15, _rect, _polyline, _rect2, _polyline2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 134 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b3ddee;}.cls-1,.cls-3,.cls-4{stroke:#0090b9;stroke-miterlimit:10;}.cls-1,.cls-3,.cls-4,.cls-5,.cls-7{stroke-width:1.5px;}.cls-2,.cls-4{fill:#fff;}.cls-2,.cls-6,.cls-7{stroke:#42a9d2;}.cls-2,.cls-5,.cls-6,.cls-7{stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke-width:1.88px;}.cls-3{fill:#f9f9f9;}.cls-5,.cls-7{fill:none;}.cls-5{stroke:#b3ddee;}.cls-6{fill:#edfafa;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.49,100.21v2.37H44.86v-2.37a3.33,3.33,0,0,1,3.28-3.37h7.74V87.45H73.47v9.39h7.74A3.33,3.33,0,0,1,84.49,100.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.7,86.94H21.64a7.13,7.13,0,0,1-7.08-7.18v-56a7.14,7.14,0,0,1,7.08-7.19H107.7a7.14,7.14,0,0,1,7.08,7.19v56A7.13,7.13,0,0,1,107.7,86.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.64,81.4A1.63,1.63,0,0,1,20,79.76v-56a1.64,1.64,0,0,1,1.62-1.65H107.7a1.64,1.64,0,0,1,1.63,1.65v56a1.63,1.63,0,0,1-1.63,1.64Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.66,81.23A1.64,1.64,0,0,1,20,79.58v-56a1.64,1.64,0,0,1,1.62-1.65h86.06a1.63,1.63,0,0,1,1.62,1.65v56a1.63,1.63,0,0,1-1.62,1.65Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.8,35.38V52a1.54,1.54,0,0,1-1.61,1.45H27.38A1.54,1.54,0,0,1,25.77,52V28.56a1.54,1.54,0,0,1,1.61-1.45h19a2.38,2.38,0,0,1,2.5,2.26Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 29.3,
    y1: 33.36,
    x2: 45.06,
    y2: 33.36
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 29.3,
    y1: 36.74,
    x2: 45.06,
    y2: 36.74
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 29.3,
    y1: 40.13,
    x2: 45.06,
    y2: 40.13
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 29.3,
    y1: 43.47,
    x2: 45.06,
    y2: 43.47
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 29.3,
    y1: 46.86,
    x2: 41.24,
    y2: 46.86
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.8,60.38V77a1.54,1.54,0,0,1-1.61,1.45H54.38A1.54,1.54,0,0,1,52.77,77V53.56a1.54,1.54,0,0,1,1.61-1.45h19a2.38,2.38,0,0,1,2.5,2.26Z"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 56.3,
    y1: 58.36,
    x2: 72.06,
    y2: 58.36
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 56.3,
    y1: 61.74,
    x2: 72.06,
    y2: 61.74
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 56.3,
    y1: 65.13,
    x2: 72.06,
    y2: 65.13
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 56.3,
    y1: 68.47,
    x2: 72.06,
    y2: 68.47
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 56.3,
    y1: 71.86,
    x2: 68.24,
    y2: 71.86
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.8,35.38V52a1.54,1.54,0,0,1-1.61,1.45H82.38A1.54,1.54,0,0,1,80.77,52V28.56a1.54,1.54,0,0,1,1.61-1.45h19a2.38,2.38,0,0,1,2.5,2.26Z"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 84.3,
    y1: 33.36,
    x2: 100.06,
    y2: 33.36
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 84.3,
    y1: 36.74,
    x2: 100.06,
    y2: 36.74
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 84.3,
    y1: 40.13,
    x2: 100.06,
    y2: 40.13
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 84.3,
    y1: 43.47,
    x2: 100.06,
    y2: 43.47
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 84.3,
    y1: 46.86,
    x2: 96.24,
    y2: 46.86
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 52.11,
    y: 32.78,
    width: 11.91,
    height: 10.26
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "55.65 38.18 57.12 40.01 61.16 35.23"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 79.11,
    y: 58.78,
    width: 11.91,
    height: 10.26
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "82.64 64.18 84.12 66.01 88.16 61.23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature2.b41c5ee037045439c521cbd4a5c1426e.svg";
export { ForwardRef as ReactComponent };